const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
    namespaced: true,
    state: {
        loading: false,
        ready: false,
        typeOrders: [1],
        orders: [],
        // countActiveOrders: 0,
        reason: [],
        count: {
            t1: 0,
            t2: 0,
        }
    },
    mutations: {
        setOrders(state, payload) {

            if (payload.cards){
                state.orders =  payload.cards.map(el=> {
                    return {...el, tel: `tel:+7${el.phone}`}
                })
            }
        },
        setReason(state, payload) {
            state.reason = payload.reason || state.reason;
        },
        setReady(state, payload) {
            state.ready = payload.ready;
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setTypeOrders(state, payload) {
            state.typeOrders = payload
        },
        setCount(state, payload) {
            let t1 = 0;
            let t2 = 0;
            payload.cards.forEach(el => {
                console.log('log', el.state);
                if (el.state !== 1) {
                    t2 += 1
                } else {
                    t1 += 1
                }
            })
            state.count = {t1, t2}
        },
    },
    actions: {
        /**
         * Получить заказы
         */
        async fetchOrders({commit, getters}, payload) {

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': localStorage.getItem('user'),
                }
            };

            fetch(`${BASE_URL}orders`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.result) {
                        commit('setOrders', result)
                        commit('setReason', result)
                        commit('setCount', result)
                        return true
                    } else {
                        commit('infoSnackbar/clearSnackbar', null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Ошибка получения заказов', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        return false
                    }
                })
                .catch(error => console.log('error', error));

        },
        /**
         * Заказ доставлен
         */
        async orderComplete({commit, getters}, payload) {
            console.log('log', payload);
            let formdata = new FormData();
            formdata.append("order_id", payload.order_id);
            formdata.append("coords", payload.coords);

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('user'),
                },
                body: formdata,
            };

            await fetch(`${BASE_URL}order-complete`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.result) {
                        commit('infoSnackbar/clearSnackbar', null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Заказ выполнен', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'success', {root: true})
                        return result.result
                    } else {
                        commit('infoSnackbar/clearSnackbar', null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Ошибка обработки', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        return result.result
                    }
                })
                .catch(error => console.log('error', error));

        },
        /**
         * Заказ отменен
         */
        async orderCanceled({commit, getters}, payload) {
            console.log('log', payload);
            let formdata = new FormData();
            formdata.append("order_id", payload.order_id);
            formdata.append("reason_id", payload.reason_id);
            formdata.append("coords", payload.coords);

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('user'),
                },
                body: formdata
            };

            await fetch(`${BASE_URL}order-canceled`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.result) {
                        commit('infoSnackbar/clearSnackbar', null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Заказ отменен', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'success', {root: true})
                        return result.result
                    } else {
                        commit('infoSnackbar/clearSnackbar', null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Ошибка обработки', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        return result.result
                    }
                })
                .catch(error => console.log('error', error));

        },
        /**
         * гео курьера
         */
        async placeCourier({commit, getters}, payload) {
            console.log('log', payload);
            let formdata = new FormData();
            formdata.append("coords", payload);

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('user'),
                },
                body: formdata
            };

            await fetch(`${BASE_URL}place-courier`, requestOptions)
                .then(response => response.json())
                .then(result => {console.log('result', result);})
                .catch(error => console.log('error', error));

        },
        /**
         * регистрация токена для пуш-уведомлений
         */
        async registerToken({commit, getters}, payload) {
            console.log('log', payload);
            let formdata = new FormData();
            formdata.append("token", payload || "[]");

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('user'),
                },
                body: formdata
            };

            await fetch(`${BASE_URL}register-token`, requestOptions)
                .then(response => response.json())
                .then(result => {console.log('result', result);})
                .catch(error => console.log('error', error));
        },
        /**
         * Получить статус готовности курьера
         */
        async fetchReady({commit, getters}, payload) {
            let requestOptions = {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': localStorage.getItem('user'),
                },
            };

            await fetch(`${BASE_URL}get-ready-courier`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.result) {
                        commit('setReady', result)
                        return true
                    }
                    return false
                })
                .catch(error => console.log('error', error));
        },
        /**
         * обновить статус готовности курьера
         */
        async updateReady({commit, getters}, payload) {
            console.log('log', payload);
            let formdata = new FormData();
            formdata.append("ready", payload);

            let requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem('user'),
                },
                body: formdata
            };

            await fetch(`${BASE_URL}update-ready-courier`, requestOptions)
                .then(response => response.json())
                .then(({result = false}) => {
                    if (result) {
                        let dt = (payload === 1) ? true : false
                        console.log('dt', dt);
                        commit('setReady', {'ready': dt})
                        return true
                    }
                    return false
                })
                .catch(error => console.log('error', error));
        },

    },
    getters: {
        orders(state) {
            // return state.orders
            return  state.orders.filter(el => {
                return state.typeOrders.indexOf(el.state) !== -1
            } );
        },
        reason(state) {
            return state.reason
        },
        loading(state) {
            return state.loading
        },
        count(state) {
            return state.count
        },
        ready(state) {
            return (state.ready) ? 1 : 0
        },
        // countActiveOrders(state) {
        //     //return state.countActiveOrders
        //     return  state.orders.filter(el => {
        //         return el.state === 1
        //     } ).length;
        // },

    }
}
